<template>
    <div>
        <search search-type="startups"
                @send-message="openChat">
        </search>

        <StartChatPopup
            ref="startChat"
            contactsType="ecosystem"
        />
    </div>
</template>

<script>
import Search from "@/views/Search";

export default {
    components: {
        Search,
        StartChatPopup: () => import("@/views/messages/StartChatPopup"),
    },
    methods: {
        openChat(id) {
            this.$refs.startChat.open(id)
        }
    }
}
</script>
